import { COUNTRIES } from "@/lib/countries";

// Admin-set price of a plan in a given currency code (manual per-currency, matches backend _price_for).
export const priceVal = (plan, code) => {
  if (!plan) return 0;
  const c = (code || "RWF").toUpperCase();
  const prices = plan.prices || {};
  if (prices[c] != null) return Number(prices[c]);
  if (c === "RWF") return Number(plan.amount || 0);
  if (c === "USD") return Number(plan.amountUsd || 0);
  if (c === "EUR") return Number(plan.amountEur ?? plan.amountUsd ?? 0);
  return Number(plan.amountUsd || plan.amount || 0);
};

// Format a numeric amount with the currency symbol (RWF trails, others lead).
export const fmtPrice = (val, cur) => {
  const code = ((cur && cur.code) || cur || "RWF").toUpperCase();
  const sym = (cur && cur.symbol) || code;
  const n = Number(val || 0).toLocaleString();
  return code === "RWF" ? `${n} ${sym}` : `${sym}${n}`;
};

export const planPrice = (plan, cur) => fmtPrice(priceVal(plan, (cur && cur.code) || cur), cur);

// Best-effort ISO country from an E.164 phone (longest matching dial code wins).
export const isoFromPhone = (phone) => {
  if (!phone) return "";
  const digits = String(phone).replace(/[^\d]/g, "");
  let best = "";
  let bestLen = 0;
  const MAIN = { 1: "US", 7: "RU", 44: "GB" }; // shared dial codes → main country
  for (const { iso, dial } of COUNTRIES) {
    if (dial && digits.startsWith(dial) && dial.length > bestLen) { best = MAIN[dial] || iso; bestLen = dial.length; }
  }
  return best;
};

// Auto-pick a currency for the customer based on their country; fall back to base/first active.
export const pickCurrency = (currencies, user) => {
  const list = (currencies || []).filter((c) => c && c.code && c.active !== false);
  if (!list.length) return null;
  const iso = isoFromPhone(user?.phone) || (user?.country || "").toUpperCase();
  if (iso) {
    const match = list.find((c) => (c.countries || []).includes(iso));
    if (match) return match;
  }
  return list.find((c) => c.isBase) || list.find((c) => c.code === "RWF") || list[0];
};
